// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkSlide-module__root___1u4ui","slide":"WorkSlide-module__slide___80jBt","arrows":"WorkSlide-module__arrows___1jqDy","right":"WorkSlide-module__right___30FCo"};